import BaseCrmEntity from "../base-crm-entity";

class CountryEntity extends BaseCrmEntity {
    static entityLocalName="country";
    static entityName="kphbase_country";
    static entityPluralName="kphbase_countries";
    static fields = {
        "kphbase_countryid": "kphbase_countryid",
        "kphbase_name": "kphbase_name",
        "kphbase_countrycode": "kphbase_countrycode",
        "kphbase_abbreviation": "kphbase_abbreviation"
    }
    constructor() {
        super(`${CountryEntity.entityName}`,`${CountryEntity.entityPluralName}`,`${CountryEntity.entityLocalName}`);
    }

    async getAll(mockup= false) {
        const fetchXml = `
      <fetch>
        <entity name="${CountryEntity.entityName}">
          ${Object.keys(CountryEntity.fields).map((attr)=>(`<attribute name="${attr}" />`)).join("")}
        </entity>
      </fetch>
    `;
        try {
            return !mockup?await this.fetch(fetchXml):this.getMockupData();
        }catch (e) {
            throw e;
        }

    }
    
    getMockupData(){
        const data = [
            {
                "kphbase_countryid": "9c370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Afghanistan",
                "kphbase_countrycode": "+93",
                "kphbase_abbreviation": "AF"
            },
            {
                "kphbase_countryid": "9e370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Aland Islands",
                "kphbase_countrycode": "+358",
                "kphbase_abbreviation": "AX"
            },
            {
                "kphbase_countryid": "a0370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Albania",
                "kphbase_countrycode": "+355",
                "kphbase_abbreviation": "AL"
            },
            {
                "kphbase_countryid": "a2370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Algeria",
                "kphbase_countrycode": "+213",
                "kphbase_abbreviation": "DZ"
            },
            {
                "kphbase_countryid": "a4370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "AmericanSamoa",
                "kphbase_countrycode": "+1684",
                "kphbase_abbreviation": "AS"
            },
            {
                "kphbase_countryid": "a6370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Andorra",
                "kphbase_countrycode": "+376",
                "kphbase_abbreviation": "AD"
            },
            {
                "kphbase_countryid": "a8370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Angola",
                "kphbase_countrycode": "+244",
                "kphbase_abbreviation": "AO"
            },
            {
                "kphbase_countryid": "aa370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Anguilla",
                "kphbase_countrycode": "+1264",
                "kphbase_abbreviation": "AI"
            },
            {
                "kphbase_countryid": "ac370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Antarctica",
                "kphbase_countrycode": "+672",
                "kphbase_abbreviation": "AQ"
            },
            {
                "kphbase_countryid": "ae370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Antigua and Barbuda",
                "kphbase_countrycode": "+1268",
                "kphbase_abbreviation": "AG"
            },
            {
                "kphbase_countryid": "b0370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Argentina",
                "kphbase_countrycode": "+54",
                "kphbase_abbreviation": "AR"
            },
            {
                "kphbase_countryid": "b2370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Armenia",
                "kphbase_countrycode": "+374",
                "kphbase_abbreviation": "AM"
            },
            {
                "kphbase_countryid": "b4370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Aruba",
                "kphbase_countrycode": "+297",
                "kphbase_abbreviation": "AW"
            },
            {
                "kphbase_countryid": "b6370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Australia",
                "kphbase_countrycode": "+61",
                "kphbase_abbreviation": "AU"
            },
            {
                "kphbase_countryid": "b8370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Austria",
                "kphbase_countrycode": "+43",
                "kphbase_abbreviation": "AT"
            },
            {
                "kphbase_countryid": "ba370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Azerbaijan",
                "kphbase_countrycode": "+994",
                "kphbase_abbreviation": "AZ"
            },
            {
                "kphbase_countryid": "bc370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Bahamas",
                "kphbase_countrycode": "+1242",
                "kphbase_abbreviation": "BS"
            },
            {
                "kphbase_countryid": "be370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Bahrain",
                "kphbase_countrycode": "+973",
                "kphbase_abbreviation": "BH"
            },
            {
                "kphbase_countryid": "c0370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Bangladesh",
                "kphbase_countrycode": "+880",
                "kphbase_abbreviation": "BD"
            },
            {
                "kphbase_countryid": "c2370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Barbados",
                "kphbase_countrycode": "+1246",
                "kphbase_abbreviation": "BB"
            },
            {
                "kphbase_countryid": "c4370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Belarus",
                "kphbase_countrycode": "+375",
                "kphbase_abbreviation": "BY"
            },
            {
                "kphbase_countryid": "c6370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Belgium",
                "kphbase_countrycode": "+32",
                "kphbase_abbreviation": "BE"
            },
            {
                "kphbase_countryid": "c8370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Belize",
                "kphbase_countrycode": "+501",
                "kphbase_abbreviation": "BZ"
            },
            {
                "kphbase_countryid": "ca370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Benin",
                "kphbase_countrycode": "+229",
                "kphbase_abbreviation": "BJ"
            },
            {
                "kphbase_countryid": "cc370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Bermuda",
                "kphbase_countrycode": "+1441",
                "kphbase_abbreviation": "BM"
            },
            {
                "kphbase_countryid": "ce370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Bhutan",
                "kphbase_countrycode": "+975",
                "kphbase_abbreviation": "BT"
            },
            {
                "kphbase_countryid": "d0370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Bolivia, Plurinational State of",
                "kphbase_countrycode": "+591",
                "kphbase_abbreviation": "BO"
            },
            {
                "kphbase_countryid": "d2370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Bosnia and Herzegovina",
                "kphbase_countrycode": "+387",
                "kphbase_abbreviation": "BA"
            },
            {
                "kphbase_countryid": "d4370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Botswana",
                "kphbase_countrycode": "+267",
                "kphbase_abbreviation": "BW"
            },
            {
                "kphbase_countryid": "d6370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Brazil",
                "kphbase_countrycode": "+55",
                "kphbase_abbreviation": "BR"
            },
            {
                "kphbase_countryid": "d8370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "British Indian Ocean Territory",
                "kphbase_countrycode": "+246",
                "kphbase_abbreviation": "IO"
            },
            {
                "kphbase_countryid": "da370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Brunei Darussalam",
                "kphbase_countrycode": "+673",
                "kphbase_abbreviation": "BN"
            },
            {
                "kphbase_countryid": "dc370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Bulgaria",
                "kphbase_countrycode": "+359",
                "kphbase_abbreviation": "BG"
            },
            {
                "kphbase_countryid": "de370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Burkina Faso",
                "kphbase_countrycode": "+226",
                "kphbase_abbreviation": "BF"
            },
            {
                "kphbase_countryid": "e0370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Burundi",
                "kphbase_countrycode": "+257",
                "kphbase_abbreviation": "BI"
            },
            {
                "kphbase_countryid": "e2370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Cambodia",
                "kphbase_countrycode": "+855",
                "kphbase_abbreviation": "KH"
            },
            {
                "kphbase_countryid": "e4370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Cameroon",
                "kphbase_countrycode": "+237",
                "kphbase_abbreviation": "CM"
            },
            {
                "kphbase_countryid": "e6370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Canada",
                "kphbase_countrycode": "+1",
                "kphbase_abbreviation": "CA"
            },
            {
                "kphbase_countryid": "e8370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Cape Verde",
                "kphbase_countrycode": "+238",
                "kphbase_abbreviation": "CV"
            },
            {
                "kphbase_countryid": "ea370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Cayman Islands",
                "kphbase_countrycode": "+ 345",
                "kphbase_abbreviation": "KY"
            },
            {
                "kphbase_countryid": "ec370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Central African Republic",
                "kphbase_countrycode": "+236",
                "kphbase_abbreviation": "CF"
            },
            {
                "kphbase_countryid": "ee370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Chad",
                "kphbase_countrycode": "+235",
                "kphbase_abbreviation": "TD"
            },
            {
                "kphbase_countryid": "f0370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Chile",
                "kphbase_countrycode": "+56",
                "kphbase_abbreviation": "CL"
            },
            {
                "kphbase_countryid": "f2370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "China",
                "kphbase_countrycode": "+86",
                "kphbase_abbreviation": "CN"
            },
            {
                "kphbase_countryid": "f4370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Christmas Island",
                "kphbase_countrycode": "+61",
                "kphbase_abbreviation": "CX"
            },
            {
                "kphbase_countryid": "f6370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Cocos (Keeling) Islands",
                "kphbase_countrycode": "+61",
                "kphbase_abbreviation": "CC"
            },
            {
                "kphbase_countryid": "f8370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Colombia",
                "kphbase_countrycode": "+57",
                "kphbase_abbreviation": "CO"
            },
            {
                "kphbase_countryid": "fa370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Comoros",
                "kphbase_countrycode": "+269",
                "kphbase_abbreviation": "KM"
            },
            {
                "kphbase_countryid": "fc370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Congo",
                "kphbase_countrycode": "+242",
                "kphbase_abbreviation": "CG"
            },
            {
                "kphbase_countryid": "fe370f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Congo, The Democratic Republic of the Congo",
                "kphbase_countrycode": "+243",
                "kphbase_abbreviation": "CD"
            },
            {
                "kphbase_countryid": "00380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Cook Islands",
                "kphbase_countrycode": "+682",
                "kphbase_abbreviation": "CK"
            },
            {
                "kphbase_countryid": "02380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Costa Rica",
                "kphbase_countrycode": "+506",
                "kphbase_abbreviation": "CR"
            },
            {
                "kphbase_countryid": "04380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Cote d'Ivoire",
                "kphbase_countrycode": "+225",
                "kphbase_abbreviation": "CI"
            },
            {
                "kphbase_countryid": "06380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Croatia",
                "kphbase_countrycode": "+385",
                "kphbase_abbreviation": "HR"
            },
            {
                "kphbase_countryid": "08380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Cuba",
                "kphbase_countrycode": "+53",
                "kphbase_abbreviation": "CU"
            },
            {
                "kphbase_countryid": "0a380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Cyprus",
                "kphbase_countrycode": "+357",
                "kphbase_abbreviation": "CY"
            },
            {
                "kphbase_countryid": "0c380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Czech Republic",
                "kphbase_countrycode": "+420",
                "kphbase_abbreviation": "CZ"
            },
            {
                "kphbase_countryid": "0e380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Denmark",
                "kphbase_countrycode": "+45",
                "kphbase_abbreviation": "DK"
            },
            {
                "kphbase_countryid": "10380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Djibouti",
                "kphbase_countrycode": "+253",
                "kphbase_abbreviation": "DJ"
            },
            {
                "kphbase_countryid": "12380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Dominica",
                "kphbase_countrycode": "+1767",
                "kphbase_abbreviation": "DM"
            },
            {
                "kphbase_countryid": "14380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Dominican Republic",
                "kphbase_countrycode": "+1849",
                "kphbase_abbreviation": "DO"
            },
            {
                "kphbase_countryid": "16380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Ecuador",
                "kphbase_countrycode": "+593",
                "kphbase_abbreviation": "EC"
            },
            {
                "kphbase_countryid": "18380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Egypt",
                "kphbase_countrycode": "+20",
                "kphbase_abbreviation": "EG"
            },
            {
                "kphbase_countryid": "1a380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "El Salvador",
                "kphbase_countrycode": "+503",
                "kphbase_abbreviation": "SV"
            },
            {
                "kphbase_countryid": "1c380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Equatorial Guinea",
                "kphbase_countrycode": "+240",
                "kphbase_abbreviation": "GQ"
            },
            {
                "kphbase_countryid": "1e380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Eritrea",
                "kphbase_countrycode": "+291",
                "kphbase_abbreviation": "ER"
            },
            {
                "kphbase_countryid": "20380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Estonia",
                "kphbase_countrycode": "+372",
                "kphbase_abbreviation": "EE"
            },
            {
                "kphbase_countryid": "22380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Ethiopia",
                "kphbase_countrycode": "+251",
                "kphbase_abbreviation": "ET"
            },
            {
                "kphbase_countryid": "24380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Falkland Islands (Malvinas)",
                "kphbase_countrycode": "+500",
                "kphbase_abbreviation": "FK"
            },
            {
                "kphbase_countryid": "26380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Faroe Islands",
                "kphbase_countrycode": "+298",
                "kphbase_abbreviation": "FO"
            },
            {
                "kphbase_countryid": "28380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Fiji",
                "kphbase_countrycode": "+679",
                "kphbase_abbreviation": "FJ"
            },
            {
                "kphbase_countryid": "2a380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Finland",
                "kphbase_countrycode": "+358",
                "kphbase_abbreviation": "FI"
            },
            {
                "kphbase_countryid": "2c380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "France",
                "kphbase_countrycode": "+33",
                "kphbase_abbreviation": "FR"
            },
            {
                "kphbase_countryid": "2e380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "French Guiana",
                "kphbase_countrycode": "+594",
                "kphbase_abbreviation": "GF"
            },
            {
                "kphbase_countryid": "30380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "French Polynesia",
                "kphbase_countrycode": "+689",
                "kphbase_abbreviation": "PF"
            },
            {
                "kphbase_countryid": "32380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Gabon",
                "kphbase_countrycode": "+241",
                "kphbase_abbreviation": "GA"
            },
            {
                "kphbase_countryid": "34380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Gambia",
                "kphbase_countrycode": "+220",
                "kphbase_abbreviation": "GM"
            },
            {
                "kphbase_countryid": "36380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Georgia",
                "kphbase_countrycode": "+995",
                "kphbase_abbreviation": "GE"
            },
            {
                "kphbase_countryid": "38380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Germany",
                "kphbase_countrycode": "+49",
                "kphbase_abbreviation": "DE"
            },
            {
                "kphbase_countryid": "3a380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Ghana",
                "kphbase_countrycode": "+233",
                "kphbase_abbreviation": "GH"
            },
            {
                "kphbase_countryid": "3c380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Gibraltar",
                "kphbase_countrycode": "+350",
                "kphbase_abbreviation": "GI"
            },
            {
                "kphbase_countryid": "3e380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Greece",
                "kphbase_countrycode": "+30",
                "kphbase_abbreviation": "GR"
            },
            {
                "kphbase_countryid": "40380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Greenland",
                "kphbase_countrycode": "+299",
                "kphbase_abbreviation": "GL"
            },
            {
                "kphbase_countryid": "42380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Grenada",
                "kphbase_countrycode": "+1473",
                "kphbase_abbreviation": "GD"
            },
            {
                "kphbase_countryid": "44380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Guadeloupe",
                "kphbase_countrycode": "+590",
                "kphbase_abbreviation": "GP"
            },
            {
                "kphbase_countryid": "46380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Guam",
                "kphbase_countrycode": "+1671",
                "kphbase_abbreviation": "GU"
            },
            {
                "kphbase_countryid": "48380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Guatemala",
                "kphbase_countrycode": "+502",
                "kphbase_abbreviation": "GT"
            },
            {
                "kphbase_countryid": "4a380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Guernsey",
                "kphbase_countrycode": "+44",
                "kphbase_abbreviation": "GG"
            },
            {
                "kphbase_countryid": "4c380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Guinea",
                "kphbase_countrycode": "+224",
                "kphbase_abbreviation": "GN"
            },
            {
                "kphbase_countryid": "4e380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Guinea-Bissau",
                "kphbase_countrycode": "+245",
                "kphbase_abbreviation": "GW"
            },
            {
                "kphbase_countryid": "50380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Guyana",
                "kphbase_countrycode": "+595",
                "kphbase_abbreviation": "GY"
            },
            {
                "kphbase_countryid": "52380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Haiti",
                "kphbase_countrycode": "+509",
                "kphbase_abbreviation": "HT"
            },
            {
                "kphbase_countryid": "54380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Holy See (Vatican City State)",
                "kphbase_countrycode": "+379",
                "kphbase_abbreviation": "VA"
            },
            {
                "kphbase_countryid": "56380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Honduras",
                "kphbase_countrycode": "+504",
                "kphbase_abbreviation": "HN"
            },
            {
                "kphbase_countryid": "58380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Hong Kong",
                "kphbase_countrycode": "+852",
                "kphbase_abbreviation": "HK"
            },
            {
                "kphbase_countryid": "5a380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Hungary",
                "kphbase_countrycode": "+36",
                "kphbase_abbreviation": "HU"
            },
            {
                "kphbase_countryid": "5c380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Iceland",
                "kphbase_countrycode": "+354",
                "kphbase_abbreviation": "IS"
            },
            {
                "kphbase_countryid": "5e380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "India",
                "kphbase_countrycode": "+91",
                "kphbase_abbreviation": "IN"
            },
            {
                "kphbase_countryid": "60380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Indonesia",
                "kphbase_countrycode": "+62",
                "kphbase_abbreviation": "ID"
            },
            {
                "kphbase_countryid": "62380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Iran, Islamic Republic of Persian Gulf",
                "kphbase_countrycode": "+98",
                "kphbase_abbreviation": "IR"
            },
            {
                "kphbase_countryid": "64380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Iraq",
                "kphbase_countrycode": "+964",
                "kphbase_abbreviation": "IQ"
            },
            {
                "kphbase_countryid": "66380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Ireland",
                "kphbase_countrycode": "+353",
                "kphbase_abbreviation": "IE"
            },
            {
                "kphbase_countryid": "68380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Isle of Man",
                "kphbase_countrycode": "+44",
                "kphbase_abbreviation": "IM"
            },
            {
                "kphbase_countryid": "6a380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Israel",
                "kphbase_countrycode": "+972",
                "kphbase_abbreviation": "IL"
            },
            {
                "kphbase_countryid": "6c380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Italy",
                "kphbase_countrycode": "+39",
                "kphbase_abbreviation": "IT"
            },
            {
                "kphbase_countryid": "6e380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Jamaica",
                "kphbase_countrycode": "+1876",
                "kphbase_abbreviation": "JM"
            },
            {
                "kphbase_countryid": "70380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Japan",
                "kphbase_countrycode": "+81",
                "kphbase_abbreviation": "JP"
            },
            {
                "kphbase_countryid": "72380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Jersey",
                "kphbase_countrycode": "+44",
                "kphbase_abbreviation": "JE"
            },
            {
                "kphbase_countryid": "74380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Jordan",
                "kphbase_countrycode": "+962",
                "kphbase_abbreviation": "JO"
            },
            {
                "kphbase_countryid": "76380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Kazakhstan",
                "kphbase_countrycode": "+77",
                "kphbase_abbreviation": "KZ"
            },
            {
                "kphbase_countryid": "78380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Kenya",
                "kphbase_countrycode": "+254",
                "kphbase_abbreviation": "KE"
            },
            {
                "kphbase_countryid": "7a380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Kiribati",
                "kphbase_countrycode": "+686",
                "kphbase_abbreviation": "KI"
            },
            {
                "kphbase_countryid": "7c380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Korea, Democratic People's Republic of Korea",
                "kphbase_countrycode": "+850",
                "kphbase_abbreviation": "KP"
            },
            {
                "kphbase_countryid": "7e380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Korea, Republic of South Korea",
                "kphbase_countrycode": "+82",
                "kphbase_abbreviation": "KR"
            },
            {
                "kphbase_countryid": "80380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Kuwait",
                "kphbase_countrycode": "+965",
                "kphbase_abbreviation": "KW"
            },
            {
                "kphbase_countryid": "82380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Kyrgyzstan",
                "kphbase_countrycode": "+996",
                "kphbase_abbreviation": "KG"
            },
            {
                "kphbase_countryid": "84380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Laos",
                "kphbase_countrycode": "+856",
                "kphbase_abbreviation": "LA"
            },
            {
                "kphbase_countryid": "86380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Latvia",
                "kphbase_countrycode": "+371",
                "kphbase_abbreviation": "LV"
            },
            {
                "kphbase_countryid": "88380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Lebanon",
                "kphbase_countrycode": "+961",
                "kphbase_abbreviation": "LB"
            },
            {
                "kphbase_countryid": "8a380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Lesotho",
                "kphbase_countrycode": "+266",
                "kphbase_abbreviation": "LS"
            },
            {
                "kphbase_countryid": "8c380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Liberia",
                "kphbase_countrycode": "+231",
                "kphbase_abbreviation": "LR"
            },
            {
                "kphbase_countryid": "8e380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Libyan Arab Jamahiriya",
                "kphbase_countrycode": "+218",
                "kphbase_abbreviation": "LY"
            },
            {
                "kphbase_countryid": "90380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Liechtenstein",
                "kphbase_countrycode": "+423",
                "kphbase_abbreviation": "LI"
            },
            {
                "kphbase_countryid": "92380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Lithuania",
                "kphbase_countrycode": "+370",
                "kphbase_abbreviation": "LT"
            },
            {
                "kphbase_countryid": "94380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Luxembourg",
                "kphbase_countrycode": "+352",
                "kphbase_abbreviation": "LU"
            },
            {
                "kphbase_countryid": "96380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Macao",
                "kphbase_countrycode": "+853",
                "kphbase_abbreviation": "MO"
            },
            {
                "kphbase_countryid": "98380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Macedonia",
                "kphbase_countrycode": "+389",
                "kphbase_abbreviation": "MK"
            },
            {
                "kphbase_countryid": "9a380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Madagascar",
                "kphbase_countrycode": "+261",
                "kphbase_abbreviation": "MG"
            },
            {
                "kphbase_countryid": "9c380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Malawi",
                "kphbase_countrycode": "+265",
                "kphbase_abbreviation": "MW"
            },
            {
                "kphbase_countryid": "9e380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Malaysia",
                "kphbase_countrycode": "+60",
                "kphbase_abbreviation": "MY"
            },
            {
                "kphbase_countryid": "a0380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Maldives",
                "kphbase_countrycode": "+960",
                "kphbase_abbreviation": "MV"
            },
            {
                "kphbase_countryid": "a2380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Mali",
                "kphbase_countrycode": "+223",
                "kphbase_abbreviation": "ML"
            },
            {
                "kphbase_countryid": "a4380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Malta",
                "kphbase_countrycode": "+356",
                "kphbase_abbreviation": "MT"
            },
            {
                "kphbase_countryid": "a6380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Marshall Islands",
                "kphbase_countrycode": "+692",
                "kphbase_abbreviation": "MH"
            },
            {
                "kphbase_countryid": "a8380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Martinique",
                "kphbase_countrycode": "+596",
                "kphbase_abbreviation": "MQ"
            },
            {
                "kphbase_countryid": "aa380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Mauritania",
                "kphbase_countrycode": "+222",
                "kphbase_abbreviation": "MR"
            },
            {
                "kphbase_countryid": "ac380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Mauritius",
                "kphbase_countrycode": "+230",
                "kphbase_abbreviation": "MU"
            },
            {
                "kphbase_countryid": "ae380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Mayotte",
                "kphbase_countrycode": "+262",
                "kphbase_abbreviation": "YT"
            },
            {
                "kphbase_countryid": "b0380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Mexico",
                "kphbase_countrycode": "+52",
                "kphbase_abbreviation": "MX"
            },
            {
                "kphbase_countryid": "b2380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Micronesia, Federated States of Micronesia",
                "kphbase_countrycode": "+691",
                "kphbase_abbreviation": "FM"
            },
            {
                "kphbase_countryid": "b4380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Moldova",
                "kphbase_countrycode": "+373",
                "kphbase_abbreviation": "MD"
            },
            {
                "kphbase_countryid": "b6380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Monaco",
                "kphbase_countrycode": "+377",
                "kphbase_abbreviation": "MC"
            },
            {
                "kphbase_countryid": "b8380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Mongolia",
                "kphbase_countrycode": "+976",
                "kphbase_abbreviation": "MN"
            },
            {
                "kphbase_countryid": "ba380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Montenegro",
                "kphbase_countrycode": "+382",
                "kphbase_abbreviation": "ME"
            },
            {
                "kphbase_countryid": "bc380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Montserrat",
                "kphbase_countrycode": "+1664",
                "kphbase_abbreviation": "MS"
            },
            {
                "kphbase_countryid": "be380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Morocco",
                "kphbase_countrycode": "+212",
                "kphbase_abbreviation": "MA"
            },
            {
                "kphbase_countryid": "c0380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Mozambique",
                "kphbase_countrycode": "+258",
                "kphbase_abbreviation": "MZ"
            },
            {
                "kphbase_countryid": "c2380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Myanmar",
                "kphbase_countrycode": "+95",
                "kphbase_abbreviation": "MM"
            },
            {
                "kphbase_countryid": "c4380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Namibia",
                "kphbase_countrycode": "+264",
                "kphbase_abbreviation": "NA"
            },
            {
                "kphbase_countryid": "c6380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Nauru",
                "kphbase_countrycode": "+674",
                "kphbase_abbreviation": "NR"
            },
            {
                "kphbase_countryid": "c8380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Nepal",
                "kphbase_countrycode": "+977",
                "kphbase_abbreviation": "NP"
            },
            {
                "kphbase_countryid": "ca380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Netherlands",
                "kphbase_countrycode": "+31",
                "kphbase_abbreviation": "NL"
            },
            {
                "kphbase_countryid": "cc380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Netherlands Antilles",
                "kphbase_countrycode": "+599",
                "kphbase_abbreviation": "AN"
            },
            {
                "kphbase_countryid": "ce380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "New Caledonia",
                "kphbase_countrycode": "+687",
                "kphbase_abbreviation": "NC"
            },
            {
                "kphbase_countryid": "d0380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "New Zealand",
                "kphbase_countrycode": "+64",
                "kphbase_abbreviation": "NZ"
            },
            {
                "kphbase_countryid": "d2380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Nicaragua",
                "kphbase_countrycode": "+505",
                "kphbase_abbreviation": "NI"
            },
            {
                "kphbase_countryid": "d4380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Niger",
                "kphbase_countrycode": "+227",
                "kphbase_abbreviation": "NE"
            },
            {
                "kphbase_countryid": "d6380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Nigeria",
                "kphbase_countrycode": "+234",
                "kphbase_abbreviation": "NG"
            },
            {
                "kphbase_countryid": "d8380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Niue",
                "kphbase_countrycode": "+683",
                "kphbase_abbreviation": "NU"
            },
            {
                "kphbase_countryid": "da380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Norfolk Island",
                "kphbase_countrycode": "+672",
                "kphbase_abbreviation": "NF"
            },
            {
                "kphbase_countryid": "dc380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Northern Mariana Islands",
                "kphbase_countrycode": "+1670",
                "kphbase_abbreviation": "MP"
            },
            {
                "kphbase_countryid": "de380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Norway",
                "kphbase_countrycode": "+47",
                "kphbase_abbreviation": "NO"
            },
            {
                "kphbase_countryid": "e0380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Oman",
                "kphbase_countrycode": "+968",
                "kphbase_abbreviation": "OM"
            },
            {
                "kphbase_countryid": "e2380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Pakistan",
                "kphbase_countrycode": "+92",
                "kphbase_abbreviation": "PK"
            },
            {
                "kphbase_countryid": "e4380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Palau",
                "kphbase_countrycode": "+680",
                "kphbase_abbreviation": "PW"
            },
            {
                "kphbase_countryid": "e6380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Palestinian Territory, Occupied",
                "kphbase_countrycode": "+970",
                "kphbase_abbreviation": "PS"
            },
            {
                "kphbase_countryid": "e8380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Panama",
                "kphbase_countrycode": "+507",
                "kphbase_abbreviation": "PA"
            },
            {
                "kphbase_countryid": "ea380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Papua New Guinea",
                "kphbase_countrycode": "+675",
                "kphbase_abbreviation": "PG"
            },
            {
                "kphbase_countryid": "ec380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Paraguay",
                "kphbase_countrycode": "+595",
                "kphbase_abbreviation": "PY"
            },
            {
                "kphbase_countryid": "ee380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Peru",
                "kphbase_countrycode": "+51",
                "kphbase_abbreviation": "PE"
            },
            {
                "kphbase_countryid": "f0380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Philippines",
                "kphbase_countrycode": "+63",
                "kphbase_abbreviation": "PH"
            },
            {
                "kphbase_countryid": "f2380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Pitcairn",
                "kphbase_countrycode": "+872",
                "kphbase_abbreviation": "PN"
            },
            {
                "kphbase_countryid": "f4380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Poland",
                "kphbase_countrycode": "+48",
                "kphbase_abbreviation": "PL"
            },
            {
                "kphbase_countryid": "f6380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Portugal",
                "kphbase_countrycode": "+351",
                "kphbase_abbreviation": "PT"
            },
            {
                "kphbase_countryid": "f8380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Puerto Rico",
                "kphbase_countrycode": "+1939",
                "kphbase_abbreviation": "PR"
            },
            {
                "kphbase_countryid": "fa380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Qatar",
                "kphbase_countrycode": "+974",
                "kphbase_abbreviation": "QA"
            },
            {
                "kphbase_countryid": "fc380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Romania",
                "kphbase_countrycode": "+40",
                "kphbase_abbreviation": "RO"
            },
            {
                "kphbase_countryid": "fe380f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Russia",
                "kphbase_countrycode": "+7",
                "kphbase_abbreviation": "RU"
            },
            {
                "kphbase_countryid": "00390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Rwanda",
                "kphbase_countrycode": "+250",
                "kphbase_abbreviation": "RW"
            },
            {
                "kphbase_countryid": "02390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Reunion",
                "kphbase_countrycode": "+262",
                "kphbase_abbreviation": "RE"
            },
            {
                "kphbase_countryid": "04390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Saint Barthelemy",
                "kphbase_countrycode": "+590",
                "kphbase_abbreviation": "BL"
            },
            {
                "kphbase_countryid": "06390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Saint Helena, Ascension and Tristan Da Cunha",
                "kphbase_countrycode": "+290",
                "kphbase_abbreviation": "SH"
            },
            {
                "kphbase_countryid": "08390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Saint Kitts and Nevis",
                "kphbase_countrycode": "+1869",
                "kphbase_abbreviation": "KN"
            },
            {
                "kphbase_countryid": "0a390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Saint Lucia",
                "kphbase_countrycode": "+1758",
                "kphbase_abbreviation": "LC"
            },
            {
                "kphbase_countryid": "0c390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Saint Martin",
                "kphbase_countrycode": "+590",
                "kphbase_abbreviation": "MF"
            },
            {
                "kphbase_countryid": "0e390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Saint Pierre and Miquelon",
                "kphbase_countrycode": "+508",
                "kphbase_abbreviation": "PM"
            },
            {
                "kphbase_countryid": "10390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Saint Vincent and the Grenadines",
                "kphbase_countrycode": "+1784",
                "kphbase_abbreviation": "VC"
            },
            {
                "kphbase_countryid": "12390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Samoa",
                "kphbase_countrycode": "+685",
                "kphbase_abbreviation": "WS"
            },
            {
                "kphbase_countryid": "14390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "San Marino",
                "kphbase_countrycode": "+378",
                "kphbase_abbreviation": "SM"
            },
            {
                "kphbase_countryid": "16390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Sao Tome and Principe",
                "kphbase_countrycode": "+239",
                "kphbase_abbreviation": "ST"
            },
            {
                "kphbase_countryid": "18390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Saudi Arabia",
                "kphbase_countrycode": "+966",
                "kphbase_abbreviation": "SA"
            },
            {
                "kphbase_countryid": "1a390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Senegal",
                "kphbase_countrycode": "+221",
                "kphbase_abbreviation": "SN"
            },
            {
                "kphbase_countryid": "1c390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Serbia",
                "kphbase_countrycode": "+381",
                "kphbase_abbreviation": "RS"
            },
            {
                "kphbase_countryid": "1e390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Seychelles",
                "kphbase_countrycode": "+248",
                "kphbase_abbreviation": "SC"
            },
            {
                "kphbase_countryid": "20390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Sierra Leone",
                "kphbase_countrycode": "+232",
                "kphbase_abbreviation": "SL"
            },
            {
                "kphbase_countryid": "22390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Singapore",
                "kphbase_countrycode": "+65",
                "kphbase_abbreviation": "SG"
            },
            {
                "kphbase_countryid": "24390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Slovakia",
                "kphbase_countrycode": "+421",
                "kphbase_abbreviation": "SK"
            },
            {
                "kphbase_countryid": "26390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Slovenia",
                "kphbase_countrycode": "+386",
                "kphbase_abbreviation": "SI"
            },
            {
                "kphbase_countryid": "28390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Solomon Islands",
                "kphbase_countrycode": "+677",
                "kphbase_abbreviation": "SB"
            },
            {
                "kphbase_countryid": "2a390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Somalia",
                "kphbase_countrycode": "+252",
                "kphbase_abbreviation": "SO"
            },
            {
                "kphbase_countryid": "2c390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "South Africa",
                "kphbase_countrycode": "+27",
                "kphbase_abbreviation": "ZA"
            },
            {
                "kphbase_countryid": "2e390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "South Sudan",
                "kphbase_countrycode": "+211",
                "kphbase_abbreviation": "SS"
            },
            {
                "kphbase_countryid": "30390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "South Georgia and the South Sandwich Islands",
                "kphbase_countrycode": "+500",
                "kphbase_abbreviation": "GS"
            },
            {
                "kphbase_countryid": "32390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Spain",
                "kphbase_countrycode": "+34",
                "kphbase_abbreviation": "ES"
            },
            {
                "kphbase_countryid": "34390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Sri Lanka",
                "kphbase_countrycode": "+94",
                "kphbase_abbreviation": "LK"
            },
            {
                "kphbase_countryid": "36390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Sudan",
                "kphbase_countrycode": "+249",
                "kphbase_abbreviation": "SD"
            },
            {
                "kphbase_countryid": "38390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Suriname",
                "kphbase_countrycode": "+597",
                "kphbase_abbreviation": "SR"
            },
            {
                "kphbase_countryid": "3a390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Svalbard and Jan Mayen",
                "kphbase_countrycode": "+47",
                "kphbase_abbreviation": "SJ"
            },
            {
                "kphbase_countryid": "3c390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Swaziland",
                "kphbase_countrycode": "+268",
                "kphbase_abbreviation": "SZ"
            },
            {
                "kphbase_countryid": "3e390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Sweden",
                "kphbase_countrycode": "+46",
                "kphbase_abbreviation": "SE"
            },
            {
                "kphbase_countryid": "40390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Switzerland",
                "kphbase_countrycode": "+41",
                "kphbase_abbreviation": "CH"
            },
            {
                "kphbase_countryid": "42390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Syrian Arab Republic",
                "kphbase_countrycode": "+963",
                "kphbase_abbreviation": "SY"
            },
            {
                "kphbase_countryid": "44390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Taiwan",
                "kphbase_countrycode": "+886",
                "kphbase_abbreviation": "TW"
            },
            {
                "kphbase_countryid": "46390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Tajikistan",
                "kphbase_countrycode": "+992",
                "kphbase_abbreviation": "TJ"
            },
            {
                "kphbase_countryid": "48390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Tanzania, United Republic of Tanzania",
                "kphbase_countrycode": "+255",
                "kphbase_abbreviation": "TZ"
            },
            {
                "kphbase_countryid": "4a390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Thailand",
                "kphbase_countrycode": "+66",
                "kphbase_abbreviation": "TH"
            },
            {
                "kphbase_countryid": "4c390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Timor-Leste",
                "kphbase_countrycode": "+670",
                "kphbase_abbreviation": "TL"
            },
            {
                "kphbase_countryid": "4e390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Togo",
                "kphbase_countrycode": "+228",
                "kphbase_abbreviation": "TG"
            },
            {
                "kphbase_countryid": "50390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Tokelau",
                "kphbase_countrycode": "+690",
                "kphbase_abbreviation": "TK"
            },
            {
                "kphbase_countryid": "52390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Tonga",
                "kphbase_countrycode": "+676",
                "kphbase_abbreviation": "TO"
            },
            {
                "kphbase_countryid": "54390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Trinidad and Tobago",
                "kphbase_countrycode": "+1868",
                "kphbase_abbreviation": "TT"
            },
            {
                "kphbase_countryid": "56390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Tunisia",
                "kphbase_countrycode": "+216",
                "kphbase_abbreviation": "TN"
            },
            {
                "kphbase_countryid": "58390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Turkey",
                "kphbase_countrycode": "+90",
                "kphbase_abbreviation": "TR"
            },
            {
                "kphbase_countryid": "5a390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Turkmenistan",
                "kphbase_countrycode": "+993",
                "kphbase_abbreviation": "TM"
            },
            {
                "kphbase_countryid": "5c390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Turks and Caicos Islands",
                "kphbase_countrycode": "+1649",
                "kphbase_abbreviation": "TC"
            },
            {
                "kphbase_countryid": "5e390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Tuvalu",
                "kphbase_countrycode": "+688",
                "kphbase_abbreviation": "TV"
            },
            {
                "kphbase_countryid": "60390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Uganda",
                "kphbase_countrycode": "+256",
                "kphbase_abbreviation": "UG"
            },
            {
                "kphbase_countryid": "62390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Ukraine",
                "kphbase_countrycode": "+380",
                "kphbase_abbreviation": "UA"
            },
            {
                "kphbase_countryid": "64390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "United Arab Emirates",
                "kphbase_countrycode": "+971",
                "kphbase_abbreviation": "AE"
            },
            {
                "kphbase_countryid": "66390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "United Kingdom",
                "kphbase_countrycode": "+44",
                "kphbase_abbreviation": "GB"
            },
            {
                "kphbase_countryid": "68390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "United States",
                "kphbase_countrycode": "+1",
                "kphbase_abbreviation": "US"
            },
            {
                "kphbase_countryid": "6a390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Uruguay",
                "kphbase_countrycode": "+598",
                "kphbase_abbreviation": "UY"
            },
            {
                "kphbase_countryid": "6c390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Uzbekistan",
                "kphbase_countrycode": "+998",
                "kphbase_abbreviation": "UZ"
            },
            {
                "kphbase_countryid": "6e390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Vanuatu",
                "kphbase_countrycode": "+678",
                "kphbase_abbreviation": "VU"
            },
            {
                "kphbase_countryid": "70390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Venezuela, Bolivarian Republic of Venezuela",
                "kphbase_countrycode": "+58",
                "kphbase_abbreviation": "VE"
            },
            {
                "kphbase_countryid": "72390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Vietnam",
                "kphbase_countrycode": "+84",
                "kphbase_abbreviation": "VN"
            },
            {
                "kphbase_countryid": "74390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Virgin Islands, British",
                "kphbase_countrycode": "+1284",
                "kphbase_abbreviation": "VG"
            },
            {
                "kphbase_countryid": "76390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Virgin Islands, U.S.",
                "kphbase_countrycode": "+1340",
                "kphbase_abbreviation": "VI"
            },
            {
                "kphbase_countryid": "78390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Wallis and Futuna",
                "kphbase_countrycode": "+681",
                "kphbase_abbreviation": "WF"
            },
            {
                "kphbase_countryid": "7a390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Yemen",
                "kphbase_countrycode": "+967",
                "kphbase_abbreviation": "YE"
            },
            {
                "kphbase_countryid": "7c390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Zambia",
                "kphbase_countrycode": "+260",
                "kphbase_abbreviation": "ZM"
            },
            {
                "kphbase_countryid": "7e390f43-1499-f011-acde-005056a3637f",
                "kphbase_name": "Zimbabwe",
                "kphbase_countrycode": "+263",
                "kphbase_abbreviation": "ZW"
            }
        ];

        return {total:data.length, value:data}
    }

}
export default CountryEntity;
